/**
 * Correlation ID di sessione.
 *
 * Un unico identificativo persistente per la sessione del browser viene
 * allegato a ogni segnalazione di runtime, insieme all'identificativo della
 * build: così un errore visto dall'utente si può seguire fino al commit e
 * all'artifact (source map) corrispondente.
 */

const KEY = "lumen.correlation-id.v1";

function randomId(): string {
  try {
    if (typeof crypto !== "undefined" && "randomUUID" in crypto) return crypto.randomUUID();
  } catch {
    // fallback sotto
  }
  return `c-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

/** Identificativo stabile per la sessione corrente (persistente sul dispositivo). */
export function getCorrelationId(): string {
  if (typeof window === "undefined") return "ssr";
  try {
    const existing = window.localStorage.getItem(KEY);
    if (existing) return existing;
    const id = randomId();
    window.localStorage.setItem(KEY, id);
    return id;
  } catch {
    return randomId();
  }
}

/** Identificativo della build servita al client (commit o timestamp di build). */
export function getBuildId(): string {
  const env = import.meta.env as Record<string, string | undefined>;
  return env["VITE_BUILD_ID"] ?? "dev";
}

/** Canale di rilascio: utile per distinguere preview, produzione e app nativa. */
export function getReleaseChannel(): string {
  const env = import.meta.env as Record<string, string | undefined>;
  if (env["VITE_RELEASE_CHANNEL"]) return env["VITE_RELEASE_CHANNEL"]!;
  if (import.meta.env.DEV) return "dev";
  if (typeof window !== "undefined" && window.location.hostname.includes("-dev.")) return "preview";
  return "production";
}
